module.exports = __webpack_public_path__ + "static/img/1076fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/livepoint/dlb.png
// module id = 656
// module chunks = 2